import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			emptyStateStyle: {
				background: 'white',
				padding: 15,
				marginTop: 16
			}
		}
	)
)

const EmptyState = () => {
	const classes = useStyle()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const titleClass: ClassValue = classNames(
		classes.colorAccessibility,
		isLargeScreen ? classes.title7 : classes.title3
	)

	return (
		<div className={classes.emptyStateStyle}>
			<h1 className={titleClass}>
				<FormattedMessage
					id="dashboard.news.emptyState"
					defaultMessage="Aucune actualité à afficher pour votre résidence"
					description="News empty state message"
				/>
			</h1>
		</div>
	)
}

export default EmptyState
